var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _path60, _path61, _path62, _path63, _path64, _path65, _path66, _path67, _path68, _path69, _path70, _path71, _path72, _path73, _path74, _path75, _path76, _path77, _path78, _path79, _path80, _path81, _path82, _path83, _path84, _path85, _path86, _path87, _path88, _path89, _path90, _path91, _path92, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMasterLeague(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "100%",
    height: "100%",
    viewBox: "0 0 51 58",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_4655_315716)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "screen"
    },
    d: "M25.0024 55.0518C38.8095 55.0518 50.0024 43.8386 50.0024 30.0064C50.0024 16.1742 38.8095 4.96094 25.0024 4.96094C11.1952 4.96094 0.00235748 16.1742 0.00235748 30.0064C0.00235748 43.8386 11.1952 55.0518 25.0024 55.0518Z",
    fill: "url(#paint0_radial_4655_315716)"
  }), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M25.0916 13.2979C25.0916 13.2979 24.1594 11.171 24.0777 7.57851C23.9688 2.85437 25.3161 0.00488281 25.3161 0.00488281C25.3161 0.00488281 20.3488 0.754747 12.4759 8.28065C12.4759 8.28065 14.667 9.03052 14.8031 10.5234C14.9392 12.0232 13.3537 18.472 13.3537 18.472C13.3537 18.472 18.5116 13.5979 25.0916 13.2911V13.2979Z",
    fill: "url(#paint1_linear_4655_315716)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.1984 15.2951C15.1984 15.2951 17.0425 9.22118 13.7763 8.04867C13.7763 8.04867 18.1108 3.61766 23.3231 2.38379C23.3231 2.38379 22.8264 7.19655 23.9559 12.2956C23.9559 12.2956 19.9616 12.1525 15.1916 15.2951H15.1984Z",
    fill: "url(#paint2_linear_4655_315716)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M14.4618 7.9021C14.4618 7.9021 18.3608 3.74376 22.7566 3.08252C22.7566 3.08252 22.8042 8.72013 23.6208 12.0195C23.6208 12.0195 19.1502 11.89 15.7887 14.5486C15.7887 14.5486 17.204 10.0563 14.4618 7.9021Z",
    fill: "#200E11"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "soft-light"
    }
  }, _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M14.7481 6.219C14.3058 6.91433 17.1161 4.56248 20.4707 3.2809C23.8254 2.00613 24.7576 0.349609 24.7576 0.349609C24.7576 0.349609 20.845 1.06539 14.7549 6.21218L14.7481 6.219Z",
    fill: "#A092A4"
  }))), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M22.8107 2.12749C22.7631 2.40016 22.8447 2.29791 23.3074 2.17521C23.7701 2.0525 24.6003 0.566406 24.6003 0.566406C24.6003 0.566406 22.9196 1.46624 22.8107 2.12749Z",
    fill: "#563D5C"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.5
  }, _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M13.7763 8.04867L14.899 8.30771C14.899 8.30771 16.3756 6.13993 19.254 4.67428C22.1391 3.20864 22.7719 3.76081 22.7719 3.76081L23.3231 2.38379C23.3231 2.38379 18.485 3.12002 13.7763 8.04867Z",
    fill: "#74432F"
  }))), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M25.815 13.2979C25.815 13.2979 26.7472 11.171 26.8289 7.57851C26.9377 2.85437 25.5904 0.00488281 25.5904 0.00488281C25.5904 0.00488281 30.5578 0.754747 38.4307 8.28065C38.4307 8.28065 36.2396 9.03052 36.1035 10.5234C35.9674 12.0232 37.5529 18.472 37.5529 18.472C37.5529 18.472 32.395 13.5979 25.815 13.2911V13.2979Z",
    fill: "url(#paint3_linear_4655_315716)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M35.7097 15.2951C35.7097 15.2951 33.8656 9.22118 37.1318 8.04867C37.1318 8.04867 32.7973 3.61766 27.585 2.38379C27.585 2.38379 28.0818 7.19655 26.9522 12.2956C26.9522 12.2956 30.9465 12.1525 35.7165 15.2951H35.7097Z",
    fill: "url(#paint4_linear_4655_315716)"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M36.4432 7.9021C36.4432 7.9021 32.5442 3.74376 28.1484 3.08252C28.1484 3.08252 28.1008 8.72013 27.2842 12.0195C27.2842 12.0195 31.7548 11.89 35.1163 14.5486C35.1163 14.5486 33.7009 10.0563 36.4432 7.9021Z",
    fill: "#200E11"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "soft-light"
    }
  }, _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M36.1583 6.219C36.6006 6.91433 33.7903 4.56248 30.4356 3.2809C27.081 2.00613 26.1488 0.349609 26.1488 0.349609C26.1488 0.349609 30.0614 1.06539 36.1515 6.21218L36.1583 6.219Z",
    fill: "#A092A4"
  }))), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M28.0868 2.12749C28.1344 2.40016 28.0527 2.29791 27.59 2.17521C27.1273 2.0525 26.2972 0.566406 26.2972 0.566406C26.2972 0.566406 27.9779 1.46624 28.0868 2.12749Z",
    fill: "#563D5C"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.5
  }, _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M37.1322 8.04867L36.0095 8.30771C36.0095 8.30771 34.5329 6.13993 31.6546 4.67428C28.7694 3.20864 28.1366 3.76081 28.1366 3.76081L27.5854 2.38379C27.5854 2.38379 32.4235 3.12002 37.1322 8.04867Z",
    fill: "#74432F"
  }))), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M25.3161 12.7915C14.4832 12.7915 5.69854 21.5922 5.69854 32.4379C5.69854 43.2837 14.4832 52.0912 25.3161 52.0912C36.149 52.0912 44.9269 43.2905 44.9269 32.4379C44.9269 21.5854 36.1422 12.7915 25.3161 12.7915ZM25.3161 47.7624C16.8648 47.7624 10.0194 40.9046 10.0194 32.4379C10.0194 23.9713 16.8648 17.1203 25.3161 17.1203C33.7674 17.1203 40.606 23.9781 40.606 32.4379C40.606 40.8978 33.7606 47.7624 25.3161 47.7624Z",
    fill: "url(#paint5_linear_4655_315716)"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M25.3148 14.7788C15.5707 14.7788 7.67737 22.6865 7.67737 32.4483C7.67737 42.2102 15.5707 50.1178 25.3148 50.1178C35.059 50.1178 42.9523 42.2102 42.9523 32.4483C42.9523 22.6865 35.059 14.7788 25.3148 14.7788ZM25.3148 47.7728C16.8635 47.7728 10.0181 40.915 10.0181 32.4483C10.0181 23.9817 16.8635 17.1307 25.3148 17.1307C33.7661 17.1307 40.6047 23.9885 40.6047 32.4483C40.6047 40.9082 33.7593 47.7728 25.3148 47.7728Z",
    fill: "url(#paint6_linear_4655_315716)"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M7.4615 27.6798C7.4615 27.6798 10.4827 16.7523 22.0845 14.0868L20.5399 4.59766C20.5399 4.59766 16.1441 6.45187 11.7484 12.8053C11.7484 12.8053 12.4765 14.3527 11.9933 15.7025C11.5102 17.0522 9.27152 21.1492 7.21654 18.6474L8.91088 22.6762L8.09433 24.2305L5.44055 17.3249C5.44055 17.3249 4.97783 19.4041 5.29765 22.2331C5.3725 22.9216 7.4547 27.6798 7.4547 27.6798H7.4615Z",
    fill: "url(#paint7_linear_4655_315716)"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M7.2156 18.6396L6.90939 20.1326L8.24989 22.6821L8.90994 22.6753L7.2156 18.6396Z",
    fill: "#1A070B"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M5.20121 20.8911C5.20121 20.8911 5.13316 21.7296 5.13316 23.1952C5.13316 23.6588 6.6778 27.6808 6.6778 27.6808H7.46033C7.46033 27.6808 5.1808 22.2681 5.20121 20.8911Z",
    fill: "#200E11"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M11.7454 12.7983C11.7454 12.7983 11.5344 14.0254 11.5344 14.1413C11.5344 14.2571 12.4735 15.416 11.0037 17.5974C11.0037 17.5974 13.0178 15.8387 11.7454 12.7915V12.7983Z",
    fill: "#200E11"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M12.476 18.6433C12.476 18.6433 13.1088 16.9049 12.9864 12.9988C12.9864 12.9988 16.1301 8.077 19.4847 6.44775C19.4847 6.44775 19.8794 12.6512 19.8794 13.5715C19.8794 13.5715 15.2863 15.2757 12.476 18.6501V18.6433Z",
    fill: "url(#paint8_linear_4655_315716)"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M13.039 17.1263C13.039 17.1263 13.4881 14.829 13.4405 12.9953C13.4405 12.9953 16.9449 7.76666 19.2108 7.08496C19.2108 7.08496 19.2992 12.6067 19.2108 13.1043C19.1223 13.602 16.3529 14.6245 13.039 17.1263Z",
    fill: "url(#paint9_linear_4655_315716)"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M5.1334 23.1968C5.1334 23.1968 6.34462 30.4773 2.56808 31.4657C2.51364 38.678 9.39987 43.0886 9.39987 43.0886C9.39987 43.0886 6.37864 38.6099 6.67804 27.6755L5.1334 23.1899V23.1968Z",
    fill: "url(#paint10_linear_4655_315716)"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M7.90765 40.9956C7.90765 40.9956 3.62077 37.9825 3.55952 32.0586C3.55952 32.0586 6.02958 30.1771 5.70296 25.3848C5.70296 25.3848 6.4923 27.7366 6.45827 28.6774C6.43105 29.6181 6.59436 35.7942 7.90765 41.0024V40.9956Z",
    fill: "url(#paint11_linear_4655_315716)"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M7.25714 40.1194C7.25714 40.1194 3.74598 37.3927 3.83444 32.0618C3.83444 32.0618 5.43351 31.8232 5.97788 27.4331L6.29769 28.5511C6.29769 28.5511 6.39296 35.7907 7.25714 40.1194Z",
    fill: "url(#paint12_linear_4655_315716)"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M2.56069 31.4614C2.56069 31.4614 4.9491 29.9481 5.28932 26.5601C5.28932 26.5601 5.5479 30.8002 2.56069 31.4614Z",
    fill: "#563D5C"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M7.21564 18.6424C7.21564 18.6424 8.25674 19.549 9.31825 19.1059C10.373 18.6696 11.5093 16.9927 11.5093 16.9927C11.5093 16.9927 10.0259 19.365 8.90998 19.5695C7.79403 19.774 7.21564 18.6424 7.21564 18.6424Z",
    fill: "#563D5C"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.5
  }, _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M13.039 12.8011L13.4405 13.5442C13.4405 13.5442 15.373 10.2584 17.1898 8.83368C18.9998 7.40894 19.2516 7.65435 19.2516 7.65435L19.483 6.44775C19.483 6.44775 17.3667 7.46348 15.6316 9.58355C13.8964 11.7036 13.039 12.8011 13.039 12.8011Z",
    fill: "#74432F"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.5
  }, _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M3.55952 32.1243L3.92697 32.8946C3.92697 32.8946 4.15833 32.1106 4.58021 31.7902C5.00209 31.4698 5.83225 30.9995 6.06361 29.8679C6.29496 28.7362 6.09763 26.698 6.09763 26.698L5.70296 25.3755C5.70296 25.3755 5.97515 27.8023 5.13138 29.7861C4.28761 31.7698 3.55952 32.1174 3.55952 32.1174V32.1243Z",
    fill: "#74432F"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "soft-light"
    },
    opacity: 0.5
  }, _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M13.3523 16.4045C13.3523 16.4045 13.958 13.7663 15.8292 12.2598C17.7005 10.7533 18.5374 12.587 18.5783 13.1051C18.6259 13.6232 13.3523 16.4045 13.3523 16.4045Z",
    fill: "#5315FF"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "soft-light"
    },
    opacity: 0.5
  }, _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M5.97694 38.5335C5.97694 38.5335 4.88821 37.4632 4.86779 35.943C4.84738 34.4228 5.69795 33.448 5.97694 33.114C6.25593 32.7868 7.02484 39.5765 7.02484 39.5765L5.97694 38.5335Z",
    fill: "#5315FF"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "soft-light"
    }
  }, _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M18.3813 8.76095C17.8573 8.3383 18.1091 9.81076 18.3813 9.988C18.6535 10.1652 18.6058 8.93819 18.3813 8.76095Z",
    fill: "#A686FF"
  }))), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M15.7964 8.28635C15.5447 8.74308 19.0422 6.698 19.4845 6.44577C19.92 6.19354 20.4644 4.85742 20.4644 4.85742C20.4644 4.85742 17.1982 6.20036 15.7964 8.28635Z",
    fill: "#563D5C"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M13.0408 17.1269L12.476 18.6403C12.476 18.6403 13.7893 17.4201 14.6807 16.5338C15.5721 15.6408 15.7898 15.5386 15.7898 15.5386C15.7898 15.5386 13.939 16.2339 13.0408 17.1269Z",
    fill: "#82574C"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M43.4502 27.6798C43.4502 27.6798 40.429 16.7523 28.8272 14.0868L30.3651 4.59766C30.3651 4.59766 34.7608 6.45187 39.1566 12.8053C39.1566 12.8053 38.4285 14.3527 38.9116 15.7025C39.3947 17.0522 41.6334 21.1492 43.6884 18.6474L41.9941 22.6762L42.8106 24.2305L45.4644 17.3249C45.4644 17.3249 45.9271 19.4041 45.6073 22.2331C45.5324 22.9216 43.4502 27.6798 43.4502 27.6798Z",
    fill: "url(#paint13_linear_4655_315716)"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M43.6972 18.6396L44.0034 20.1326L42.6697 23.2752L42.0029 22.6753L43.6972 18.6396Z",
    fill: "#1A070B"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M45.7083 20.8906C45.7083 20.8906 45.7763 21.7291 45.7763 23.1948C45.7763 23.6583 44.2385 27.6803 44.2385 27.6803H43.456C43.456 27.6803 45.7355 22.2676 45.7151 20.8906H45.7083Z",
    fill: "#200E11"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M39.1641 12.7983C39.1641 12.7983 39.375 14.0254 39.375 14.1413C39.375 14.2571 38.436 15.416 39.9058 17.5974C39.9058 17.5974 37.8916 15.8387 39.1641 12.7915V12.7983Z",
    fill: "#200E11"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M38.4356 18.6433C38.4356 18.6433 37.8028 16.9049 37.9252 12.9988C37.9252 12.9988 34.7815 8.077 31.4269 6.44775C31.4269 6.44775 31.0322 12.6512 31.0322 13.5715C31.0322 13.5715 35.6253 15.2757 38.4356 18.6501V18.6433Z",
    fill: "url(#paint14_linear_4655_315716)"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M37.8699 17.1263C37.8699 17.1263 37.4208 14.829 37.4684 12.9953C37.4684 12.9953 33.9641 7.76666 31.6981 7.08496C31.6981 7.08496 31.6097 12.6067 31.6981 13.1043C31.7866 13.602 34.5561 14.6245 37.8699 17.1263Z",
    fill: "url(#paint15_linear_4655_315716)"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M45.777 23.1968C45.777 23.1968 44.5658 30.4773 48.3423 31.4657C48.3968 38.678 41.5105 43.0886 41.5105 43.0886C41.5105 43.0886 44.5318 38.6099 44.2324 27.6755L45.7702 23.1899L45.777 23.1968Z",
    fill: "url(#paint16_linear_4655_315716)"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M42.9994 40.9956C42.9994 40.9956 47.2863 37.9825 47.3475 32.0586C47.3475 32.0586 44.8774 30.1771 45.2041 25.3848C45.2041 25.3848 44.4147 27.7366 44.4487 28.6774C44.476 29.6181 44.3127 35.7942 42.9994 41.0024V40.9956Z",
    fill: "url(#paint17_linear_4655_315716)"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M43.6543 40.1194C43.6543 40.1194 47.1654 37.3927 47.077 32.0618C47.077 32.0618 45.4779 31.8232 44.9335 27.4331L44.6137 28.5511C44.6137 28.5511 44.5185 35.7907 43.6543 40.1194Z",
    fill: "url(#paint18_linear_4655_315716)"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M48.3509 31.4614C48.3509 31.4614 45.9625 29.9481 45.6222 26.5601C45.6222 26.5601 45.3637 30.8002 48.3509 31.4614Z",
    fill: "#563D5C"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M43.6958 18.6424C43.6958 18.6424 42.6547 19.549 41.5932 19.1059C40.5385 18.6696 39.4022 16.9927 39.4022 16.9927C39.4022 16.9927 40.8855 19.365 42.0015 19.5695C43.1174 19.774 43.6958 18.6424 43.6958 18.6424Z",
    fill: "#563D5C"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.5
  }, _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M37.8695 12.8011L37.4681 13.5442C37.4681 13.5442 35.5356 10.2584 33.7188 8.83368C31.9087 7.40894 31.657 7.65435 31.657 7.65435L31.4256 6.44775C31.4256 6.44775 33.5418 7.46348 35.277 9.58355C37.0122 11.7036 37.8695 12.8011 37.8695 12.8011Z",
    fill: "#74432F"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.5
  }, _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M47.3471 32.1243L46.9729 32.8946C46.9729 32.8946 46.7415 32.1106 46.3196 31.7902C45.8977 31.4698 45.0676 30.9995 44.8362 29.8679C44.6049 28.7362 44.8022 26.698 44.8022 26.698L45.1969 25.3755C45.1969 25.3755 44.9247 27.8023 45.7685 29.7861C46.6122 31.7698 47.3403 32.1174 47.3403 32.1174L47.3471 32.1243Z",
    fill: "#74432F"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "soft-light"
    },
    opacity: 0.5
  }, _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M37.5564 16.4045C37.5564 16.4045 36.9508 13.7663 35.0796 12.2598C33.2083 10.7533 32.3714 12.587 32.3305 13.1051C32.2829 13.6232 37.5564 16.4045 37.5564 16.4045Z",
    fill: "#5315FF"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "soft-light"
    },
    opacity: 0.5
  }, _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M44.9336 38.5335C44.9336 38.5335 46.0223 37.4632 46.0427 35.943C46.0631 34.4228 45.2126 33.448 44.9336 33.114C44.6546 32.7868 43.8857 39.5765 43.8857 39.5765L44.9336 38.5335Z",
    fill: "#5315FF"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "soft-light"
    }
  }, _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "M32.529 8.76144C33.0529 8.33879 32.8011 9.81125 32.529 9.98849C32.2568 10.1657 32.3044 8.93868 32.529 8.76144Z",
    fill: "#A686FF"
  }))), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    d: "M35.1136 8.28635C35.3653 8.74308 31.8678 6.698 31.4255 6.44577C30.99 6.19354 30.4456 4.85742 30.4456 4.85742C30.4456 4.85742 33.7118 6.20036 35.1136 8.28635Z",
    fill: "#563D5C"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    d: "M37.8708 17.1269L38.4356 18.6403C38.4356 18.6403 37.1223 17.4201 36.2309 16.5338C35.3395 15.6408 35.1218 15.5386 35.1218 15.5386C35.1218 15.5386 36.9726 16.2339 37.8708 17.1269Z",
    fill: "#82574C"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.5
  }, _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    d: "M7.91058 29.5482C7.91058 29.5482 13.5176 17.1141 25.3167 17.1141C37.1158 17.1141 42.8997 31.1024 42.8997 31.1024C42.8997 31.1024 39.2797 14.769 25.3167 14.769C11.3537 14.769 7.91058 29.5482 7.91058 29.5482Z",
    fill: "#74432F"
  }))), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    d: "M24.8672 14.771C24.8672 14.771 27.2624 13.8916 30.2973 14.471C33.3253 15.0437 35.877 18.2885 35.877 18.2885C35.877 18.2885 32.1821 14.8937 24.8672 14.771Z",
    fill: "#563D5C"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    d: "M14.8917 46.6954C13.803 45.8297 20.417 47.9565 25.5885 47.8952C30.76 47.8338 38.871 43.7505 38.871 43.7505C38.871 43.7505 34.1759 49.4699 26.1805 50.1107C18.1919 50.7515 14.8917 46.6954 14.8917 46.6954Z",
    fill: "#5A4361"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    d: "M41.87 38.011C41.3052 37.9905 40.8493 39.1971 41.4413 39.947C42.0265 40.6901 43.1493 38.0655 41.87 38.011Z",
    fill: "#200E11"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.5
  }, _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    d: "M41.2443 38.9453C41.3532 39.5793 42.1493 39.4089 42.3602 39.0135C42.578 38.6113 42.3806 37.8819 41.7955 38.0182C41.2103 38.1545 41.2375 38.9453 41.2375 38.9453H41.2443Z",
    fill: "#BE7D2F"
  }))), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    d: "M41.2229 39.5231C41.2977 39.1072 41.8693 39.4481 42.1551 39.3935C42.4409 39.339 42.1143 40.0752 41.7673 40.0684C41.4202 40.0684 41.2161 39.5231 41.2161 39.5231H41.2229Z",
    fill: "#5A4361"
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    d: "M14.1698 46.1387C14.1698 46.1387 15.9322 48.4564 20.9199 49.8266C20.9199 49.8266 18.1573 47.3316 14.1698 46.1387Z",
    fill: "#634D6A"
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    d: "M25.4061 50.764C25.4061 50.764 21.5411 50.7504 14.7705 48.4326L16.145 54.6633C16.145 54.6633 20.9286 57.9763 25.4061 57.9763C29.8835 57.9763 34.6671 54.6633 34.6671 54.6633L36.0416 48.4326C29.2711 50.7572 25.4061 50.764 25.4061 50.764Z",
    fill: "url(#paint19_linear_4655_315716)"
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    d: "M16.7279 50.1128C16.7279 50.1128 23.5052 52.3487 34.2496 50.181L33.7937 53.5554C33.7937 53.5554 30.4391 56.9638 25.3152 56.9638C20.1914 56.9638 17.245 54.0121 17.245 54.0121L16.7211 50.1128H16.7279Z",
    fill: "url(#paint20_linear_4655_315716)"
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    d: "M17.3618 51.018C17.3618 51.018 26.4051 52.5177 33.7472 50.8066L33.3526 53.5402C33.3526 53.5402 30.4266 56.1648 25.4865 56.4374C20.8049 56.6965 17.7633 53.8675 17.7633 53.8675L17.3618 51.0248V51.018Z",
    fill: "#67FFF7"
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    d: "M25.9556 56.947C25.9556 56.947 26.5135 56.6606 28.5277 55.9449C30.5487 55.2291 32.0525 54.9087 32.0525 54.9087C32.0525 54.9087 28.8271 57.1174 25.9556 56.9401V56.947Z",
    fill: "#6B5570"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.5
  }, _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    d: "M16.7279 50.1128L17.5444 51.2649C17.5444 51.2649 21.1917 52.376 25.4854 52.376C29.779 52.376 33.7257 50.924 33.7257 50.924L34.2428 50.181C34.2428 50.181 24.4511 52.301 16.7211 50.1128H16.7279Z",
    fill: "#74432F"
  }))), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    d: "M11.2362 43.0786C11.2362 43.0786 7.96316 40.3245 7.67737 32.894C7.67737 32.894 7.80666 37.2228 11.2362 43.0786Z",
    fill: "#5A4361"
  })), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    d: "M45.4706 17.3228L45.7836 23.1921C45.7836 23.1921 46.4368 18.9247 45.4706 17.3228Z",
    fill: "#563D5C"
  })), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    d: "M5.4391 17.3228L5.12609 23.1921C5.12609 23.1921 4.17345 18.5021 5.4391 17.3228Z",
    fill: "#563D5C"
  })), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    d: "M2.56069 31.4592C2.56069 31.4592 3.20713 31.4319 3.42487 31.3092C3.63581 31.1865 4.03048 30.6616 4.03048 30.6616L2.56069 31.4592Z",
    fill: "#67506C"
  })), _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    d: "M46.9806 30.7515C46.9806 30.7515 47.7019 30.9219 47.7767 30.9901C47.8516 31.0582 48.3483 31.4536 48.3483 31.4536C48.3483 31.4536 47.3208 31.1196 46.9806 30.7515Z",
    fill: "#67506C"
  })), _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    d: "M32.3512 48.6499C32.3512 48.6499 34.4266 46.8639 35.3452 46.5026C36.2706 46.1413 36.6516 45.8413 36.6516 45.8413C36.6516 45.8413 35.5153 47.9818 32.3444 48.6499H32.3512Z",
    fill: "#67506C"
  })), _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    d: "M16.1415 17.349C16.1415 17.349 19.4282 15.0789 24.8582 14.7721C24.8582 14.7721 21.0817 13.8041 16.1415 17.349Z",
    fill: "#573E5D"
  })), _path70 || (_path70 = /*#__PURE__*/React.createElement("path", {
    d: "M7.89818 28.3115C7.3334 28.3319 6.96596 29.5726 7.61239 30.2748C8.25202 30.9701 9.17744 28.2706 7.89818 28.3115Z",
    fill: "#200E11"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.5
  }, _path71 || (_path71 = /*#__PURE__*/React.createElement("path", {
    d: "M7.3409 29.2946C7.4974 29.9149 8.27312 29.6899 8.46365 29.2741C8.64737 28.8583 8.39561 28.1425 7.83083 28.3265C7.25924 28.5038 7.3477 29.2946 7.3477 29.2946H7.3409Z",
    fill: "#BE7D2F"
  }))), _path72 || (_path72 = /*#__PURE__*/React.createElement("path", {
    d: "M7.36169 29.8667C7.40252 29.4441 8.00132 29.7372 8.28712 29.669C8.5661 29.5941 8.30073 30.3507 7.95369 30.3712C7.60666 30.3916 7.3685 29.8667 7.3685 29.8667H7.36169Z",
    fill: "#5A4361"
  })), _path73 || (_path73 = /*#__PURE__*/React.createElement("path", {
    d: "M12.4148 21.514L13.2653 21.9367C13.2653 21.9367 17.8856 16.5649 24.8671 16.5649C31.8486 16.5649 36.4689 21.4118 36.4689 21.4118L37.5509 20.7096C37.5509 20.7096 33.053 15.3311 24.8671 15.3311C16.6812 15.3311 12.408 21.5072 12.408 21.5072L12.4148 21.514Z",
    fill: "url(#paint21_linear_4655_315716)"
  })), _path74 || (_path74 = /*#__PURE__*/React.createElement("path", {
    d: "M12.742 21.0989L13.2727 21.5148C13.2727 21.5148 18.0903 16.3339 24.9902 16.3339C31.89 16.3339 36.3742 20.9012 36.3742 20.9012L37.2724 20.4036C37.2724 20.4036 32.9447 15.4204 25.0038 15.4204C17.0629 15.4204 12.7351 21.0989 12.7351 21.0989H12.742Z",
    fill: "url(#paint22_linear_4655_315716)"
  })), _path75 || (_path75 = /*#__PURE__*/React.createElement("path", {
    d: "M10.3582 45.1542C10.3582 45.1542 10.957 43.5727 11.236 43.2523C11.515 42.9319 13.706 42.4206 13.706 42.4206C13.706 42.4206 12.6922 42.482 12.3792 42.6183C12.0593 42.7546 10.8413 42.1207 10.6372 42.1411C10.4331 42.1616 10.365 45.1542 10.365 45.1542H10.3582Z",
    fill: "#200E11"
  })), _path76 || (_path76 = /*#__PURE__*/React.createElement("path", {
    d: "M10.9163 43.8028C10.9163 43.8028 11.3517 43.5301 11.4334 43.4824C11.5151 43.4415 12.3384 42.7734 12.3384 42.7734C12.3384 42.7734 11.4334 42.8961 11.202 42.9916C10.9775 43.0802 10.9094 43.8028 10.9094 43.8028H10.9163Z",
    fill: "#4F3555"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.5
  }, _path77 || (_path77 = /*#__PURE__*/React.createElement("path", {
    d: "M10.4148 44.7781C10.4148 44.7781 11.0748 43.1352 11.2109 42.9988C11.347 42.8625 11.4967 42.5762 11.4967 42.5762C11.4967 42.5762 10.7482 42.099 10.6325 42.1331C10.5169 42.1672 10.374 44.1782 10.4148 44.7781Z",
    fill: "#74432F"
  }))), _path78 || (_path78 = /*#__PURE__*/React.createElement("path", {
    d: "M11.1427 43.0049C11.1427 43.0049 11.4353 43.2708 11.5509 43.2912C11.6666 43.3117 11.9864 42.8345 11.9864 42.8345C11.9864 42.8345 11.4421 42.889 11.1427 43.0049Z",
    fill: "#634D6A"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.5
  }, _path79 || (_path79 = /*#__PURE__*/React.createElement("path", {
    d: "M12.2642 42.6311C12.2642 42.6311 12.3459 42.7333 12.55 42.7197C12.7541 42.7061 13.4958 42.4675 13.4958 42.4675C13.4958 42.4675 12.897 42.447 12.271 42.6311H12.2642Z",
    fill: "#74432F"
  }))), _path80 || (_path80 = /*#__PURE__*/React.createElement("path", {
    d: "M10.7401 42.1582C10.7401 42.1582 10.0596 41.2175 9.95753 41.1971C9.86227 41.1766 10.5359 42.2741 10.5359 42.2741L10.7333 42.1582H10.7401Z",
    fill: "#78657E"
  })), _path81 || (_path81 = /*#__PURE__*/React.createElement("path", {
    d: "M11.9393 15.0327C11.9393 15.0327 10.9663 14.351 9.61895 15.3326C8.27165 16.3143 8.56425 19.1637 8.56425 19.1637C8.56425 19.1637 9.35358 20.0363 10.837 18.0389C12.3204 16.0416 11.9461 15.0327 11.9461 15.0327H11.9393Z",
    fill: "url(#paint23_linear_4655_315716)"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "soft-light"
    },
    opacity: 0.5
  }, _path82 || (_path82 = /*#__PURE__*/React.createElement("path", {
    d: "M8.82285 19.1312C8.25807 18.7699 8.91131 17.0657 10.803 16.2545C12.6947 15.4433 10.8642 18.2723 9.96602 18.8381C9.06782 19.4107 8.82285 19.1312 8.82285 19.1312Z",
    fill: "#5315FF"
  }))), _path83 || (_path83 = /*#__PURE__*/React.createElement("path", {
    d: "M10.8279 15.4962C10.6442 15.8711 11.0661 15.837 11.1885 15.5916C11.311 15.3462 10.8891 15.3666 10.8279 15.4962Z",
    fill: "#FFE9CF"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.5
  }, _path84 || (_path84 = /*#__PURE__*/React.createElement("path", {
    d: "M8.53014 18.5947C8.53014 18.5947 8.56417 16.6041 9.71414 15.6497C10.8641 14.6954 11.7011 14.9203 11.7011 14.9203C11.7011 14.9203 10.7008 14.4363 9.48278 15.4657C8.40086 16.3791 8.53695 18.5947 8.53695 18.5947H8.53014Z",
    fill: "#74432F"
  }))), _path85 || (_path85 = /*#__PURE__*/React.createElement("path", {
    d: "M39.0694 15.0327C39.0694 15.0327 40.0425 14.351 41.3898 15.3326C42.7371 16.3143 42.4445 19.1637 42.4445 19.1637C42.4445 19.1637 41.6552 20.0363 40.1718 18.0389C38.6884 16.0416 39.0626 15.0327 39.0626 15.0327H39.0694Z",
    fill: "url(#paint24_linear_4655_315716)"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "soft-light"
    },
    opacity: 0.5
  }, _path86 || (_path86 = /*#__PURE__*/React.createElement("path", {
    d: "M42.1862 19.1288C42.751 18.7675 42.0978 17.0633 40.2061 16.252C38.3144 15.434 40.1449 18.2699 41.0431 18.8357C41.9413 19.4083 42.1862 19.1288 42.1862 19.1288Z",
    fill: "#5315FF"
  }))), _path87 || (_path87 = /*#__PURE__*/React.createElement("path", {
    d: "M40.1807 15.4962C40.3645 15.8711 39.9426 15.837 39.8201 15.5916C39.6976 15.3462 40.1195 15.3666 40.1807 15.4962Z",
    fill: "#FFE9CF"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.5
  }, _path88 || (_path88 = /*#__PURE__*/React.createElement("path", {
    d: "M42.4791 18.5951C42.4791 18.5951 42.4451 16.6046 41.2951 15.6502C40.1452 14.6959 39.315 14.9208 39.315 14.9208C39.315 14.9208 40.3153 14.4368 41.5333 15.4662C42.6152 16.3796 42.4791 18.5951 42.4791 18.5951Z",
    fill: "#74432F"
  }))), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "screen"
    },
    d: "M43.2575 34.8906C44.598 32.825 46.6666 31.7957 47.8914 32.5933C49.1163 33.3908 49.021 35.7086 47.6805 37.7673C46.34 39.8329 44.2714 40.8622 43.0466 40.0646C41.8218 39.267 41.917 36.9493 43.2575 34.8906Z",
    fill: "url(#paint25_radial_4655_315716)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "screen"
    },
    d: "M30.6561 10.0354C31.9966 7.96987 34.9022 7.48586 37.1545 8.95151C39.4068 10.4172 40.1485 13.2803 38.8148 15.3458C37.4743 17.4113 34.5688 17.8953 32.3165 16.4297C30.0641 14.9641 29.3224 12.1009 30.6561 10.0422V10.0354Z",
    fill: "url(#paint26_radial_4655_315716)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "screen"
    },
    d: "M11.7422 16.521C10.2044 14.5986 10.8508 11.5242 13.1848 9.64952C15.5187 7.77486 18.6557 7.81577 20.1867 9.73814C21.7245 11.6605 21.0781 14.735 18.7441 16.6096C16.4101 18.4843 13.2732 18.4434 11.7422 16.521Z",
    fill: "url(#paint27_radial_4655_315716)"
  }), _path89 || (_path89 = /*#__PURE__*/React.createElement("path", {
    d: "M22.2446 25L18.2043 37.7424H15.9036L11.8447 25H14.3137L16.2403 31.4087L17.1194 34.7067L18.0547 31.39L19.9626 25H22.2446Z",
    fill: "url(#paint28_linear_4655_315716)"
  })), _path90 || (_path90 = /*#__PURE__*/React.createElement("path", {
    d: "M26.509 37.7424H24.2644V25H26.509V37.7424Z",
    fill: "url(#paint29_linear_4655_315716)"
  })), _path91 || (_path91 = /*#__PURE__*/React.createElement("path", {
    d: "M32.2629 37.7424H30.0183V25H32.2629V37.7424Z",
    fill: "url(#paint30_linear_4655_315716)"
  })), _path92 || (_path92 = /*#__PURE__*/React.createElement("path", {
    d: "M38.0169 37.7424H35.7723V25H38.0169V37.7424Z",
    fill: "url(#paint31_linear_4655_315716)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint0_radial_4655_315716",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(25.0024 30.0064) scale(25 25.0455)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.59,
    stopColor: "transparent",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.81,
    stopColor: "#11EADF",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#2497E9",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "transparent",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_4655_315716",
    x1: 18.8926,
    y1: 18.4788,
    x2: 18.8926,
    y2: 0.00488281,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#251216"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#382434"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_4655_315716",
    x1: 18.8661,
    y1: 15.2951,
    x2: 18.8661,
    y2: 2.38379,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#51404E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#19070A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_4655_315716",
    x1: 32.0072,
    y1: 18.4788,
    x2: 32.0072,
    y2: 0.00488281,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#251216"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#382434"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_4655_315716",
    x1: 32.042,
    y1: 15.2951,
    x2: 32.042,
    y2: 2.38379,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#51404E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#19070A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_4655_315716",
    x1: 25.3161,
    y1: 52.0912,
    x2: 25.3161,
    y2: 12.7915,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#271618"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#382434"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_4655_315716",
    x1: 25.3148,
    y1: 50.111,
    x2: 25.3148,
    y2: 14.7788,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#51404E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#19070A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_4655_315716",
    x1: 13.6333,
    y1: 27.6798,
    x2: 13.6333,
    y2: 4.59084,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#251216"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#382434"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_4655_315716",
    x1: 16.1777,
    y1: 18.6433,
    x2: 16.1777,
    y2: 6.44775,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#AE6876"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.34,
    stopColor: "#3E2D38"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#19070A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_4655_315716",
    x1: 16.1419,
    y1: 17.1263,
    x2: 16.1419,
    y2: 7.09178,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BD27FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D62454"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_4655_315716",
    x1: 5.97717,
    y1: 43.0886,
    x2: 5.97717,
    y2: 23.1968,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#251216"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#382434"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear_4655_315716",
    x1: 5.73018,
    y1: 40.9956,
    x2: 5.73018,
    y2: 25.3779,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#AE6876"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.34,
    stopColor: "#3E2D38"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#19070A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint12_linear_4655_315716",
    x1: 5.54239,
    y1: 40.1194,
    x2: 5.54239,
    y2: 27.4331,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BD27FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D62454"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint13_linear_4655_315716",
    x1: 37.2717,
    y1: 27.6798,
    x2: 37.2717,
    y2: 4.59084,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#251216"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#382434"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint14_linear_4655_315716",
    x1: 34.7339,
    y1: 18.6433,
    x2: 34.7339,
    y2: 6.44775,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#AE6876"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.34,
    stopColor: "#3E2D38"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#19070A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint15_linear_4655_315716",
    x1: 34.7602,
    y1: 17.1263,
    x2: 34.7602,
    y2: 7.09178,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BD27FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D62454"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint16_linear_4655_315716",
    x1: 44.9332,
    y1: 43.0886,
    x2: 44.9332,
    y2: 23.1968,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#251216"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#382434"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint17_linear_4655_315716",
    x1: 45.17,
    y1: 40.9956,
    x2: 45.17,
    y2: 25.3779,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#AE6876"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.34,
    stopColor: "#3E2D38"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#19070A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint18_linear_4655_315716",
    x1: 45.3622,
    y1: 40.1194,
    x2: 45.3622,
    y2: 27.4331,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BD27FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D62454"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint19_linear_4655_315716",
    x1: 25.4061,
    y1: 57.9763,
    x2: 25.4061,
    y2: 48.4326,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#251216"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#382434"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint20_linear_4655_315716",
    x1: 25.4854,
    y1: 56.9638,
    x2: 25.4854,
    y2: 50.1128,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#51404E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#19070A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint21_linear_4655_315716",
    x1: 24.9896,
    y1: 21.9367,
    x2: 24.9896,
    y2: 15.3379,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#AE6876"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.34,
    stopColor: "#3E2D38"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#19070A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint22_linear_4655_315716",
    x1: 25.0038,
    y1: 21.5148,
    x2: 25.0038,
    y2: 15.4272,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#27FFA1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2A24D6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint23_linear_4655_315716",
    x1: 10.1915,
    y1: 19.3866,
    x2: 10.318,
    y2: 14.7801,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#27E9FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8385D2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint24_linear_4655_315716",
    x1: 40.8371,
    y1: 19.3886,
    x2: 40.7106,
    y2: 14.7821,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#277DFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#11EADF"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint25_radial_4655_315716",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(46.3154 38.3686) rotate(-146.972) scale(2.64595 4.44471)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CD00FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.01,
    stopColor: "#C800F9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.18,
    stopColor: "#9400B8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.34,
    stopColor: "#670080"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.49,
    stopColor: "#420052"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.64,
    stopColor: "#25002E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.78,
    stopColor: "#100014"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    stopColor: "#040005"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint26_radial_4655_315716",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(33.7197 13.5135) rotate(-146.972) scale(4.86667 4.44471)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CD00FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.01,
    stopColor: "#C800F9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.18,
    stopColor: "#9400B8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.34,
    stopColor: "#670080"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.49,
    stopColor: "#420052"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.64,
    stopColor: "#25002E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.78,
    stopColor: "#100014"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    stopColor: "#040005"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint27_radial_4655_315716",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(14.7794 14.3914) rotate(141.249) scale(5.41096 4.44394)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CD00FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.01,
    stopColor: "#C800F9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.18,
    stopColor: "#9400B8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.34,
    stopColor: "#670080"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.49,
    stopColor: "#420052"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.64,
    stopColor: "#25002E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.78,
    stopColor: "#100014"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    stopColor: "#040005"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint28_linear_4655_315716",
    x1: 24.9308,
    y1: 25,
    x2: 24.9308,
    y2: 37.7424,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D58DC8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#11EADF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint29_linear_4655_315716",
    x1: 24.9308,
    y1: 25,
    x2: 24.9308,
    y2: 37.7424,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D58DC8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#11EADF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint30_linear_4655_315716",
    x1: 24.9308,
    y1: 25,
    x2: 24.9308,
    y2: 37.7424,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D58DC8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#11EADF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint31_linear_4655_315716",
    x1: 24.9308,
    y1: 25,
    x2: 24.9308,
    y2: 37.7424,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D58DC8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#11EADF"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_4655_315716"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 50,
    height: 58,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMasterLeague);
export default __webpack_public_path__ + "static/media/master-league.5a8ee2cf16032aa8bc46702bc1cba256.svg";
export { ForwardRef as ReactComponent };